<footer class="navbar">
  <div class="container">
    <p><span class="link-partteam" (click)="partteam()">Desenvolvido por PARTTEAM & OEMKIOSKS</span> | <span class="link-partteam" (click)="terms()">{{ 'TitleTermsFrontOffice' | translate }}</span></p>
  </div>
</footer>
